window._ = require('lodash');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.request.use(
    (config) => {
        let accessToken = localStorage.getItem('access_token');

        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${ accessToken }`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

window.axios.interceptors.response.use(
    response => response,
    error => {
        const url = error.config && error.config.url ? error.config.url : '';

        if (error.response && error.response.status === 401 && !url.includes('/api/login')) {
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_info');

            if (window.location.pathname !== '/login') {
                window.location.replace('/login');
            }
        }

        return Promise.reject(error);
    }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });

import "./assets/css/vendor/dropzone.min.css";
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "./assets/css/vendor/bootstrap.min.css";
import "./assets/css/vendor/bootstrap.rtl.only.min.css";
import 'video.js/dist/video-js.css'

import "./assets/fonts/simple-line-icons/css/simple-line-icons.css";
import "./assets/fonts/iconsmind-s/css/iconsminds.css";

import { defaultColor, themeSelectedColorStorageKey } from "./constants/config";
/*  if you want use single color theme

- ColorSwitcher component remove in 'src/App.vue' file.
- Remove multicolor section in current file
- Uncomment the two lines below

import "./assets/css/sass/themes/piaf.light.orange.scss";
import "./main";
*/

/* if you want single color remove this section:multicolor */
let color = defaultColor;

if (localStorage.getItem(themeSelectedColorStorageKey)) {
    color = localStorage.getItem(themeSelectedColorStorageKey);
}
let render = () => {
    import("./assets/css/sass/themes/piaf." + color + ".scss").then(() =>
        require("./app")
    );
};

render();
/* if you want single color remove this section:multicolor */
